module.exports = __webpack_public_path__ + "img/bj-screenshot3.5a071962.png";